import React from 'react'
import firebase from "firebase/app"
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../API/FirebaseConfig';
import { User } from 'firebase/auth';

export const AuthContext = React.createContext<User | null>(null);